/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// platform_console_admin_ui/src/api/workItems.js
import { api } from "../api";

export async function getIncidentWorkItems(incidentId) {
  const response = await api.get(
    `/api/secure/incident-workspaces/${incidentId}/work-items`
  );

  return response.data;
}

export async function getWorkItem(workItemId) {
  const response = await api.get(
    `/api/secure/work-items/${workItemId}`
  );

  return response.data;
}

export async function getMyWorkItems() {
  const response = await api.get(
    "/api/secure/my/work-items"
  );
  
  return response.data;
}

export async function updateWorkItem(
  workItemId,
  payload
) {
  const response = await api.patch(
    `/api/secure/work-items/${workItemId}`,
    payload
  );

  return response.data;
}

export async function verifyWorkItem(
  workItemId,
  verificationNotes
) {
  const response = await api.post(
    `/api/secure/work-items/${workItemId}/verify`,
    {
      verification_notes:
        verificationNotes?.trim() || null,
    }
  );

  return response.data;
}

export async function returnWorkItem(
  workItemId,
  verificationNotes
) {
  const response = await api.post(
    `/api/secure/work-items/${workItemId}/return`,
    {
      verification_notes:
        verificationNotes.trim(),
    }
  );

  return response.data;
}